// Design tokens for colors - Based on MTS UX Base Design v1
export const colors = {
  // Primary brand colors (exact hex values from UX spec)
  primary: '#2563EB',
  primaryHover: '#1D4ED8', 
  secondary: '#0F172A',
  accent: '#F59E0B',

  // Background colors
  background: '#FFFFFF',
  surface: '#F8FAFC', 
  border: '#E5E7EB',

  // Text colors
  textPrimary: '#111827',
  textSecondary: '#6B7280',

  // Status colors 
  success: '#10B981',
  warning: '#F59E0B', 
  error: '#EF4444',

  // Extended palette for Tailwind compatibility
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6', 
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827'
  },

  blue: {
    50: '#EFF6FF',
    100: '#DBEAFE', 
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB', // Primary
    700: '#1D4ED8', // Primary hover
    800: '#1E40AF',
    900: '#1E3A8A'
  },

  amber: {
    50: '#FFFBEB',
    100: '#FEF3C7',
    200: '#FDE68A', 
    300: '#FCD34D',
    400: '#FBBF24',
    500: '#F59E0B', // Accent
    600: '#D97706',
    700: '#B45309',
    800: '#92400E',
    900: '#78350F'
  },

  emerald: {
    50: '#ECFDF5',
    100: '#D1FAE5',
    200: '#A7F3D0',
    300: '#6EE7B7', 
    400: '#34D399',
    500: '#10B981', // Success
    600: '#059669',
    700: '#047857',
    800: '#065F46',
    900: '#064E3B'
  },

  red: {
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444', // Error
    600: '#DC2626',
    700: '#B91C1C',
    800: '#991B1B',
    900: '#7F1D1D'
  }
};

// Semantic color mappings for easy theming
export const semanticColors = {
  // Main brand colors
  primary: colors.primary,
  primaryHover: colors.primaryHover,
  secondary: colors.secondary, 
  accent: colors.accent,

  // Backgrounds
  background: colors.background,
  surface: colors.surface,
  border: colors.border,

  // Text
  textPrimary: colors.textPrimary,
  textSecondary: colors.textSecondary,

  // Status
  success: colors.success,
  warning: colors.warning,
  error: colors.error,

  // Component specific
  buttonPrimary: {
    bg: colors.primary,
    text: colors.background,
    hover: colors.primaryHover
  },
  
  buttonSecondary: {
    bg: colors.background,
    text: colors.textPrimary,
    border: colors.border
  },

  buttonGhost: {
    bg: 'transparent',
    text: colors.primary
  },

  // Badge colors (tier system)
  badgeBasic: {
    bg: '#E5E7EB',
    text: '#374151'
  },
  
  badgeFeatured: {
    bg: '#DBEAFE',
    text: '#1D4ED8' 
  },
  
  badgeSpotlight: {
    bg: '#FEF3C7',
    text: '#B45309'
  },

  // Table colors (admin)
  tableHeaderBg: '#F9FAFB',
  tableRowHover: '#F3F4F6', 
  tableBorder: '#E5E7EB'
};